import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_tecnicos } from "../../config/apiConfig";
import ActivarDesactivar from "../../components/perfil/ActivarDesactivarTecnicos";
import Navbar from "../../components/Navbar";
import FormularioCrearTecnico from "../../components/perfil/FormularioCrearTecnico";
import FormularioCambiarContrasena from "../../components/perfil/FormularioCambiarContrasena";
import ListadoTecnicos from "../../components/perfil/ListadoTecnicos";
import "./css/Perfil.css";
import { useAuth } from "../../context/AuthContext";
import { toast } from "react-toastify";

const Perfil = () => {
  const auth = useSelector((state) => state.auth);
  const { role, user } = auth;
  const [userData, setUserData] = useState(null);
  const { token } = useAuth();

  //para mostrar el listado de usuarios
  const [tecnicos, setTecnicos] = useState([]);

  // Estados para el modal de confirmación de eliminación
  const [deleteId, setDeleteId] = useState(null);
  const [deleteName, setDeleteName] = useState("");

  useEffect(() => {
    const fetchTecnicos = async () => {
      try {
        const response = await fetch(`${API_tecnicos}`, {
          headers: { "x-auth-token": token },
        });
        const data = await response.json();
        setTecnicos(data);

        // Buscar técnico logueado
        const { user } = auth;
        const matchedUser = data.find(
          (t) =>
            t.email === user?.email ||
            (t.name?.toLowerCase() === user?.name?.toLowerCase() &&
              t.role === role)
        );

        setUserData(matchedUser);
      } catch (error) {
        console.error("Error al obtener técnicos:", error);
      }
    };

    fetchTecnicos();
  }, [role, user]);

  // Función para eliminar técnico
  const eliminarTecnico = async () => {
    try {
      const res = await fetch(`${API_tecnicos}/${deleteId}`, {
        method: "DELETE",
        headers: { "x-auth-token": token },
      });

      if (!res.ok) throw new Error("Error al eliminar técnico");

      setTecnicos(tecnicos.filter((t) => t.id !== deleteId));
      toast.success("Técnico eliminado correctamente");
    } catch (err) {
      console.error(err);
      toast.error("No se pudo eliminar el técnico");
    } finally {
      setDeleteId(null);
    }
  };

  return (
    <>
      <Navbar />

      <main className="main perfil column">
        <section className="usuario between tecnico">
          {/* Datos del técnico: nombre, correo y rol */}
          <div className="datos-tecnico">
            <h1 className="mayusculas verde">
              {userData
                ? `${userData.name} ${userData.lastName}`
                : "Cargando..."}
            </h1>
            <p className="correo">{userData?.email}</p>
            <p>{userData?.role}</p>
          </div>

          {/* Activar/Inactivar mi perfil */}
          {role === "administrador" && (
            <ActivarDesactivar
              status={userData?.employeeStatus}
              id={userData?.id}
            />
          )}
        </section>

        {/* Cuadro Cambiar contraseña + Cuadro Crear técnico */}
        <section className="formularios between">
          <FormularioCambiarContrasena />
          {role === "administrador" && <FormularioCrearTecnico />}
        </section>

        {/* Listado de técnicos */}
        {role === "administrador" && (
          <section className="listado-tecnicos">
            <h2 className="mayusculas font-21">Listado de Técnicos</h2>
            <table className="mt-20">
              <thead>
                <tr>
                  <th className="w-250 text-left">Técnico</th>
                  <th className="w-300 text-left">Email</th>
                  <th className="w-175 text-left">Rol</th>
                  <th className="w-150 text-left">Estado</th>
                  <th className="text-left">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {tecnicos
                  .filter((tecnico) => tecnico.id !== userData?.id)
                  .map((tecnico) => (
                    <ListadoTecnicos
                      key={tecnico.id}
                      tecnico={tecnico}
                      onActualizar={(id, nuevosValores) => {
                        setTecnicos((prev) =>
                          prev.map((t) =>
                            t.id === id ? { ...t, ...nuevosValores } : t
                          )
                        );
                      }}
                      onEliminar={(id, nombre) => {
                        setDeleteId(id);
                        setDeleteName(nombre);
                      }}
                      isAdmin={role === "administrador"}
                    />
                  ))}
              </tbody>
            </table>
          </section>
        )}

        {/* Modal de confirmación de borrado */}
        {deleteId && (
          <div className="historico-seguimiento">
            <div
              className="modal-content"
              style={{ maxWidth: "400px", width: "90vw" }}
            >
              <div
                style={{
                  padding: "25px",
                  textAlign: "center",
                  background: "white",
                  borderRadius: "10px",
                }}
              >
                <div style={{ fontSize: "48px", marginBottom: "15px" }}>⚠️</div>
                <h3 style={{ marginBottom: "15px", color: "#374151" }}>
                  Confirmar eliminación
                </h3>
                <p style={{ marginBottom: "25px", color: "#6b7280" }}>
                  ¿Eliminar el técnico <strong>«{deleteName}»</strong>?<br />
                  Esta acción no se puede deshacer.
                </p>

                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    justifyContent: "center",
                  }}
                >
                  <button
                    onClick={() => setDeleteId(null)}
                    style={{
                      padding: "10px 20px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "6px",
                      background: "white",
                      color: "#6b7280",
                      cursor: "pointer",
                      fontWeight: "500",
                    }}
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={eliminarTecnico}
                    style={{
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "6px",
                      background: "#ef4444",
                      color: "white",
                      cursor: "pointer",
                      fontWeight: "500",
                    }}
                  >
                    Eliminar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </>
  );
};

export default Perfil;
